<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-row>
      
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.userStatus"
          placeholder="用户状态"
        >
          <el-option
            v-for="(item, i) in userStatusData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn_170">
        <el-select
          clearable
          multiple
          collapse-tags
          class="select_btn_style"
          v-model="filters.leaderTypeMore"
          placeholder="管理主体（多选）"
        >
          <el-option
            v-for="(item, i) in leaderTypeData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn_190" >
        <el-select
          clearable
          multiple
          collapse-tags
          class="select_btn_style cadre_level"
          v-model="filters.cadreLevels"
          placeholder="干部级别（多选）"
        >
          <el-option
            v-for="(item, i) in cadreLevelData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.isExam"
          placeholder="考核状态"
        >
          <el-option
            v-for="(item, i) in publicData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="input-style">
        <el-input
          size="small"
          v-model="filters.name"
          placeholder="请输入用户姓名"
        ></el-input>
      </el-form-item>
      <el-form-item class="input-style">
        <el-input
          size="small"
          v-model="filters.userMobile"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <!-- showTotal -->
      <el-form-item label="近五年集中培训学时数" class="m-l-14" >
        <range-input ref="totalRange" @change="totalChange"/>
      </el-form-item>
      <!-- <el-form-item label="本年度网络自学学时数：" v-if="showOnline">
        <range-input ref="onlineRange" @change="onlineChange"/>
      </el-form-item> -->
      <el-form-item class="m-l-14">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import RangeInput from "@/components/RangeInput";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  props: {
  },
  components: { butn, RangeInput },
  data() {
    return {
      filters: {},
      userStatusData: [],
      leaderTypeData: [],
      publicData: [],
      cadreLevelData: [],
    };
  },
  created() {
    this.getSysParamByTypes([
      "USER_STATUS",
      "USER_LEADER_TYPE",
      "IS_VALID",
      "CADRE_LEVEL"
    ]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["USER_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["IS_VALID"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.userStatusData = res.data["USER_STATUS"];
        this.leaderTypeData = res.data["USER_LEADER_TYPE"];
        this.publicData = res.data["IS_VALID"];
        this.cadreLevelData = res.data["CADRE_LEVEL"];
      });
    },
    initData() {
      let params = { ...this.filters };
      params.page = 1;
      this.$emit("search", params);
    },
    resetData() {
      this.filters = {};
      this.$refs.totalRange?.reset();
      // this.$refs.onlineRange?.reset();
      this.$emit("search", {});
    },
    totalChange(value) {
      if (value && value.length > 1) {
        this.filters.minTotalLength = value[0];
        this.filters.maxTotalLength = value[1];
      }
      
    },
    onlineChange(value) {
      if (value && value.length > 1) {
        this.filters.minOnlineLength = value[0];
        this.filters.maxOnlineLength = value[1];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.serach-form {
  .select_btn_220 {
    /deep/.el-form-item__content {
      width: 100%;
    }
    .select_btn_style {
      width: 100%;
    }
  }
  text-align: left;
  border-bottom: 1px dashed #ebeef5;
  margin-bottom: 20px;
  & /deep/ .none-margin-right {
    margin-right: 0;
  }
  & /deep/ .date-picker {
    width: 240px;
  }
  /deep/ .credit-input {
    width: 80px;
    border-radius: 2px;
    // border: 1px solid #dcdfe6;
    height: 30px;
    color: #606266;
    outline: none;
    -webkit-appearance: none;
    background-color: #ffffff;
    background-image: none;
    // padding: 0 10px;
    &:focus {
      border-color: #3a85ff;
    }
  }
  .sepertor {
    margin: 0 10px;
  }

  .input-style {
    margin-right: 0px !important;
  }
}
.cadre_level {
  /deep/ .el-tag {
    max-width: calc(100% - 45px) !important;
  }
}
</style>
